module.exports = __webpack_public_path__ + "img/post.7255d8da.jpg";